import React, { Component } from 'react'
import PropTypes from 'prop-types'
export default class AddTodo extends Component {
    state = {
        title:''
    }
    
    onSubmit =(e) => {
        e.preventDefault()
        // calling the function addTodo(title)
        this.props.addTodo(this.state.title);
        this.setState({title: ''});
        }

        onChange =(e)=> this.setState({[e.target.name] :e.target.value})   

    render() {
        return (
            <div>
                <form onSubmit={this.onSubmit}>
                    <input type="text"
                    onChange={this.onChange}
                     name="title"
                      id="text"
                       value={this.state.title}
                       placeholder="Add todo" />

                    <input
                    type="submit" 
                    id="submit"  
                    value="Submit" />

                </form>
            </div>
        )
    }
}
AddTodo.propTypes ={
    addTodo: PropTypes.func.isRequired
  }  